import { DEFAULT_CONSENT } from '../const/constants';

export const parseMarketingConsent = (value: string) => {
  const currentDate = new Date();

  return value
    ? {
        consentDatetime: currentDate,
        consentText: DEFAULT_CONSENT,
      }
    : '';
};
